import {Grid} from '@material-ui/core';
import {useQuoteField} from 'Quoting/components/hooks/useHandleQuoteFieldChange';
import {FormRowGrid, GridRowProps} from 'Quoting/components/shared/GridRow';
import {ConditionalSection, QuoteFormConditionalSection} from 'Quoting/components/shared/QuoteFormConditionalSection';
import {QuoteFormControlElement} from 'Quoting/components/shared/QuoteFormControlElement';
import {QuoteFormElement} from 'Quoting/components/shared/QuoteFormElement';
import {FormWrapper} from 'Quoting/components/shared/QuoteFormWrapper';
import React from 'react';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {getOptionFromValueTimePeriod, unitsOptions} from '../../PlanTemplates/ACC/benefitDefaults';
import {formatCurrencyValue} from './ACCBenefits';
import {getAccidentDiagnosticPainPath} from './PropertyPaths/propertyPathACC';

const MajorDiagnosticExam = () => {
  const {getQuoteFieldValue} = useQuoteField();
  const {selectedPlan} = useSelector((state: ReducerState) => state.quoteForm);

  const propertyPaths = getAccidentDiagnosticPainPath(selectedPlan?.planIndex || 0, 0);

  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'major-diagnostic-exam-row-1'},
      items: [
        {
          key: 'major-diagnostic-incurral-period',
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Incurral Period (Days)"
              type="number"
              value={getQuoteFieldValue<number>(propertyPaths.majorDiagnosticExamDetails.incurralPeriod)}
              id={'accDiagnostic.incurralPeriod'}
              disabled
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'major-diagnostic-exam-row-2'},
      items: [
        {
          key: 'major-diagnostic-customize-benefit-1',
          hidden: true,
          element: (
            <QuoteFormControlElement
              controlType="checkbox"
              label="Customize Benefit Amount"
              disabled
              id={'accDiagnostic.cATCustomizeBenefitAmount'}
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: 'major-diagnostic-ct-benefit-amount',
          element: (
            <QuoteFormElement
              elementType="Text"
              type="number"
              label="Computed Axial Tomography (CAT/CT) Scan - Benefit Amount"
              value={formatCurrencyValue(
                getQuoteFieldValue<number>(propertyPaths.majorDiagnosticExamDetails.cATBenefitAmount)
              )}
              id={'accDiagnostic.cATBenefitAmount'}
              disabled
              required
              adornment="money"
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'major-diagnostic-exam-row-3'},
      items: [
        {
          key: 'major-diagnostic-customize-benefit-2',
          hidden: true,
          element: (
            <QuoteFormControlElement
              controlType="checkbox"
              label="Customize Benefit Amount"
              disabled
              id={'accDiagnostic.eEGCustomizeBenefitAmount'}
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: 'major-diagnostic-eeg-benefit-amount',
          element: (
            <QuoteFormElement
              elementType="Text"
              type="number"
              label="Electroencephalogram (EEG) - Benefit Amount"
              value={formatCurrencyValue(
                getQuoteFieldValue<number>(propertyPaths.majorDiagnosticExamDetails.eEGBenefitAmount)
              )}
              id={'accDiagnostic.eEGBenefitAmount'}
              disabled
              required
              adornment="money"
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'major-diagnostic-exam-row-4'},
      items: [
        {
          key: 'major-diagnostic-customize-benefit-3',
          hidden: true,
          element: (
            <QuoteFormControlElement
              controlType="checkbox"
              label="Customize Benefit Amount"
              id={'accDiagnostic.mRICustomizeBenefitAmount'}
              disabled
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: 'major-diagnostic-mri-benefit-amount',
          element: (
            <QuoteFormElement
              elementType="Text"
              type="number"
              label="Magnetic Resonance Imaging (MRI) - Benefit Amount"
              value={formatCurrencyValue(
                getQuoteFieldValue<number>(propertyPaths.majorDiagnosticExamDetails.mRIBenefitAmount)
              )}
              id={'accDiagnostic.mRIBenefitAmount'}
              disabled
              required
              adornment="money"
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'major-diagnostic-exam-row-5'},
      items: [
        {
          key: 'major-diagnostic-customize-benefit-4',
          hidden: true,
          element: (
            <QuoteFormControlElement
              controlType="checkbox"
              label="Customize Benefit Amount"
              id={'accDiagnostic.pETCustomizeBenefitAmount'}
              disabled
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: 'major-diagnostic-pet-benefit-amount',
          element: (
            <QuoteFormElement
              elementType="Text"
              type="number"
              label="Positron Emission Tomography (PET) - Benefit Amount"
              value={formatCurrencyValue(
                getQuoteFieldValue<number>(propertyPaths.majorDiagnosticExamDetails.pETBenefitAmount)
              )}
              id={'accDiagnostic.pETBenefitAmount'}
              disabled
              required
              adornment="money"
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'major-diagnostic-exam-row-6'},
      items: [
        {
          key: 'major-diagnostic-customize-benefit-5',
          hidden: true,
          element: (
            <QuoteFormControlElement
              controlType="checkbox"
              label="Customize Benefit Amount"
              disabled
              id={'accDiagnostic.ultrasoundCustomizeBenefitAmount'}
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: 'major-diagnostic-ultrasound-benefit-amount',
          element: (
            <QuoteFormElement
              elementType="Text"
              type="number"
              label="Ultrasound - Benefit Amount"
              value={formatCurrencyValue(
                getQuoteFieldValue<number>(propertyPaths.majorDiagnosticExamDetails.ultrasoundBenefitAmount)
              )}
              id={'accDiagnostic.ultrasoundBenefitAmount'}
              disabled
              required
              adornment="money"
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'brain-injury-diagnosis-row-7'},
      items: [
        {
          key: 'major-diagnostic-payable-per-time-period',
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              dropdownVariant="AttributeValue"
              label="Number of Major Diag. Exams Payable per Time Period"
              required
              searchKey={`ACCMajorDiagnosticExamBenefit.maxBenefitNumber`}
              value={getQuoteFieldValue<string>(propertyPaths.majorDiagnosticExamDetails.maxBenefitNumber)}
              id={'accDiagnostic.maxBenefitNumber'}
              disabled
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: 'major-diagnostic-time-period',
          element: (
            <QuoteFormElement
              elementType="Select"
              label="Time Period"
              required
              disabled
              options={getOptionFromValueTimePeriod(
                getQuoteFieldValue<string>(propertyPaths.majorDiagnosticExamDetails.timePeriodCd) ?? ''
              )}
              value={getQuoteFieldValue<string>(propertyPaths.majorDiagnosticExamDetails.timePeriodCd)}
              id={'accDiagnostic.timePeriodCd'}
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
  ];

  return <FormRowGrid rows={rows} />;
};

const PainManagement = () => {
  const {getQuoteFieldValue} = useQuoteField();
  const {selectedPlan} = useSelector((state: ReducerState) => state.quoteForm);
  const propertyPaths = getAccidentDiagnosticPainPath(selectedPlan?.planIndex || 0, 0);

  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'pain-management-row-1'},
      items: [
        {
          key: 'pain-management-incurral-period',
          element: (
            <QuoteFormElement
              elementType="Text"
              type="number"
              label="Incurral Period (Days)"
              required
              value={getQuoteFieldValue<number>(propertyPaths.painManagementDetails.incurralPeriod)}
              disabled
              id={'accPainManagement.incurralPeriod'}
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: 'pain-management-benefit-amount',
          element: (
            <QuoteFormElement
              elementType="Text"
              type="number"
              label="Benefit Amount"
              disabled
              value={formatCurrencyValue(getQuoteFieldValue<number>(propertyPaths.painManagementDetails.benefitAmount))}
              id={'accPainManagement.benefitAmount'}
              required
              adornment="money"
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'pain-management-row-2'},
      items: [
        {
          key: 'epidural-injection',
          element: (
            <QuoteFormControlElement
              controlType="checkbox"
              label="Epidural Injection"
              disabled
              checked={getQuoteFieldValue<boolean>(propertyPaths.painManagementDetails.epiduralInjection)}
              id={'accPainManagement.epiduralInjection'}
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: 'nerve-ablation-procedure',
          element: (
            <QuoteFormControlElement
              controlType="checkbox"
              label="Nerve Ablation Procedure"
              disabled
              checked={getQuoteFieldValue<boolean>(propertyPaths.painManagementDetails.nerveAblationProcedure)}
              id={'accPainManagement.nerveAblationProcedure'}
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'pain-management-row-3'},
      items: [
        {
          key: 'pain-management-payable-per-time-period',
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              dropdownVariant="AttributeValue"
              label="Number of Times Benefit is Payable per Time Period"
              searchKey={`ACCPainManagementBenefit.maxBenefitNumber`}
              value={getQuoteFieldValue<number>(propertyPaths.painManagementDetails.maxBenefitNumber)}
              disabled
              required
              id={'accPainManagement.maxBenefitNumber'}
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: 'pain-management-time-period',
          element: (
            <QuoteFormElement
              elementType="Select"
              label="Time Period"
              required
              options={getOptionFromValueTimePeriod(
                getQuoteFieldValue<string>(propertyPaths.painManagementDetails.timePeriodCd) ?? ''
              )}
              value={getQuoteFieldValue<number>(propertyPaths.painManagementDetails.timePeriodCd)}
              disabled
              id={'accPainManagement.timePeriodCd'}
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
  ];

  return <FormRowGrid rows={rows} />;
};

export const PainManagementCorticosteroidInjection = () => {
  const {getQuoteFieldValue} = useQuoteField();
  const {selectedPlan, selectedProduct} = useSelector((state: ReducerState) => state.quoteForm);
  const propertyPaths = getAccidentDiagnosticPainPath(selectedPlan?.planIndex || 0, 0);

  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'pain-management-corticosteroid-injection-row-1'},
      items: [
        {
          key: 'pain-management-corticosteroid-injection-incurral-period',
          element: (
            <QuoteFormElement
              elementType="Text"
              type="number"
              label="Incurral Period (Days)"
              required
              disabled
              value={getQuoteFieldValue<number>(
                propertyPaths.painManagementCorticosteroidInjectionBenefit.incurralPeriod
              )}
              id={'accPainCorticosteroid.incurralPeriod'}
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: 'pain-management-corticosteroid-injection-customize-benefit',
          hidden: true,
          element: (
            <QuoteFormControlElement
              controlType="checkbox"
              label="Customize Benefit Amount"
              id={'accPainCorticosteroid.customizeBenefitAmount'}
              disabled
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'pain-management-corticosteroid-injection-row-2'},
      items: [
        {
          key: 'pain-management-corticosteroid-injection-benefit-amount',
          element: (
            <QuoteFormElement
              elementType="Text"
              type="number"
              label="Benefit Amount"
              disabled
              value={formatCurrencyValue(
                getQuoteFieldValue<number>(propertyPaths.painManagementCorticosteroidInjectionBenefit.benefitAmount)
              )}
              id={'accPainCorticosteroid.benefitAmount'}
              required
              adornment="money"
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: 'pain-management-corticosteroid-injection-payable-per-time-period',
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              dropdownVariant="AttributeValue"
              label="Number of Times Benefit is Payable per Time Period"
              searchKey={`ACCPainManagementCorticosteroidInjectionBenefit.maxBenefitNumber`}
              value={getQuoteFieldValue<number>(
                propertyPaths.painManagementCorticosteroidInjectionBenefit.maxBenefitNumber
              )}
              disabled
              required
              id={'accPainCorticosteroid.maxBenefitNumber'}
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'pain-management-corticosteroid-injection-row-3'},
      items: [
        {
          key: 'pain-management-corticosteroid-injection-time-period',
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              dropdownVariant="AttributeValue"
              label="Time Period"
              required
              searchKey={`ACCPainManagementCorticosteroidInjectionBenefit.timePeriodCd`}
              value={getQuoteFieldValue<number>(
                propertyPaths.painManagementCorticosteroidInjectionBenefit.timePeriodCd
              )}
              disabled
              id={'accPainCorticosteroid.timePeriodCd'}
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
  ];

  return <FormRowGrid rows={rows} />;
};

export const AccidentDiagnosticPainManagementBlock = () => {
  const {getQuoteFieldValue} = useQuoteField();
  const {selectedPlan, selectedProduct} = useSelector((state: ReducerState) => state.quoteForm);
  const propertyPaths = getAccidentDiagnosticPainPath(selectedPlan?.planIndex || 0, 0);

  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'accident-pain-management-units-row-1'},
      items: [
        {
          key: 'units',
          element: (
            <QuoteFormElement
              elementType="Select"
              label="Units"
              options={unitsOptions}
              type="number"
              value={getQuoteFieldValue<number>(propertyPaths.unitsOfDiagnosticPainManagement)}
              required
              disabled
              id={'accSurgeries.unitsOfDiagnosticPainManagement'}
            />
          ),
          props: {xs: 6, sm: 6, md: 6},
        },
      ],
    },
  ];
  const accidentDiagnosticPainManagement: ConditionalSection[] = [
    {
      Component: MajorDiagnosticExam,
      key: 'MajorDiagnosticExam',
      label: 'MAJOR DIAGNOSTIC EXAM',
      disabled: true,
      isApplied: getQuoteFieldValue<boolean>(propertyPaths.isMajorDiagnosticExamApplied),
    },
    {
      Component: PainManagement,
      key: 'PainManagement',
      label: 'PAIN MANAGEMENT',
      disabled: true,
      isApplied: getQuoteFieldValue<boolean>(propertyPaths.isPainManagementApplied),
    },
    {
      Component: PainManagementCorticosteroidInjection,
      key: 'PainManagementCorticosteroidInjection',
      label: 'PAIN MANAGEMENT - CORTICOSTEROID INJECTION',
      disabled: true,
      hidden: true,
      isApplied: getQuoteFieldValue<boolean>(propertyPaths.isPainManagementCorticosteroidInjectionApplied),
    },
  ];

  return (
    <FormWrapper title="Accident Treatment and Urgent Care - Diagnostic/Pain Management" collapsible withSeparator>
      <Grid container alignItems="center">
        <FormRowGrid rows={rows} />
        <QuoteFormConditionalSection sections={accidentDiagnosticPainManagement} />
      </Grid>
    </FormWrapper>
  );
};
